import React, { Dispatch, useMemo, useState } from "react";

import { Modal, ModalBody } from "reactstrap";
import { useSelector } from "react-redux";
import Axios from "axios";

import { handleRequest } from "utils/handleRequest";
import hasPermission from "utils/hasPermissions";
import { INavbarData } from "./navbar-shortcuts";
import { GT } from "components/index";

interface IModalAddShortcut {
    navbar?: any[];
    setNavbarData: Dispatch<React.SetStateAction<INavbarData[] | null | undefined>>;
}

export const ModalAddShortCut = (props: IModalAddShortcut) => {
    return (
        <GT.ModalWrapper className="navbar-shortcut-add-btn btn btn-custom-round ml-20" icon={"plus"}>
            {(modalOpen, closeModal) => <ModalContent modalOpen={modalOpen} closeModal={closeModal} {...props} />}
        </GT.ModalWrapper>
    );
};

interface IModalContent extends IModalAddShortcut {
    modalOpen: boolean;
    closeModal: () => void;
}

const ModalContent = (props: IModalContent) => {
    const { navbar, modalOpen, closeModal, setNavbarData } = props;

    const [formData, setFormData] = useState<any>();
    const [errors, setErrors] = useState<IErrors>({});

    const navigationSidebar = useSelector((state) => state.settings.navigation_sidebar);

    const options = useMemo(
        () =>
            Object.entries(navigationSidebar)
                .filter(([k, o]: any) => o.name && (!o.permCode ? true : hasPermission(o.permCode)))
                .map(([k, o]: any) => ({ label: o.name, value: k })),
        []
    );

    const fields: IFormField[] = [
        {
            fieldType: "primeSelect",
            name: "app",
            label: "App",
            options: options,
            props: {
                translateOptions: true,
            },
        },
        {
            fieldType: "primeSelect",
            name: "subApp",
            label: "SubApp",
            options: Object.entries(navigationSidebar?.[formData?.app]?.sub || {})
                .filter(([k, o]: any) => o.name && (!o.permCode ? true : hasPermission(o.permCode)))
                .map(([k, o]: any) => ({ label: o.name, value: k })),
            display: !!navigationSidebar?.[formData?.app]?.sub,
            props: {
                translateOptions: true,
            },
        },
    ];

    const handleSubmit = async () => {
        const shortcutAppUrl = formData?.subApp || formData?.app;
        const mainAppData = navigationSidebar[formData?.app];

        const newNavbarShortcuts = [
            ...(navbar || []),
            {
                url: shortcutAppUrl,
                label: mainAppData.sub?.[formData?.subApp]?.name || mainAppData.name,
                icon: mainAppData.sub?.[formData?.subApp]?.icon || mainAppData.icon,
            },
        ];

        await handleRequest({
            request: () =>
                Axios.post("nav-bar", {
                    navBar: newNavbarShortcuts,
                }),
            onSuccess: (response) => {
                setNavbarData([{ navBar: newNavbarShortcuts }]);
                closeModal();
            },
            setErrors,
        });
    };

    return (
        <Modal isOpen={modalOpen} fade toggle={closeModal}>
            <GT.Form disableTransactions onSubmit={handleSubmit} permCode="">
                <GT.ModalHeader closeModal={closeModal} name="Add shortcut" />
                <ModalBody>
                    <GT.FormFields fields={fields} formData={formData} setFormData={setFormData} errors={errors} />
                </ModalBody>
                <GT.ModalFooter closeModal={closeModal} cancelName="Close" okName="Add" />
            </GT.Form>
        </Modal>
    );
};
